window.$ = window.jQuery = require('jquery');

function Root() {
    this.csrf = $('meta[name="csrf-token"]').attr('content');
    this.base = $('meta[name="base-url"]').attr('content');
    this.idioma = $('meta[name="idioma"]').attr('content');
}

module.exports = Root;